import { render, staticRenderFns } from "./CommonStep.vue?vue&type=template&id=b5881caa"
import script from "./CommonStep.vue?vue&type=script&lang=js"
export * from "./CommonStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports